import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle } from '@ionic/react';
import { FC, useState } from 'react';
import { RecordingService } from './RecordingService';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useAsyncEffect } from '../support/useAsyncEffect';
import { IRecording } from './RecordingState';

export const RecordingDebugPage: FC = () => {
    const recordingService = useInstance(RecordingService);

    const [recordings, setRecordings] = useState<IRecording[]>([]);

    useAsyncEffect(async () => {
        setRecordings(await recordingService.getAll());
    }, [recordingService]);

    const deleteLocalRecordings = async () => {
        const all = await recordingService.getAll();
        all.forEach(async (recording) => await recordingService.delete(recording.id));
        setRecordings(await recordingService.getAll());
    };

    return (
        <>
            <h1>Local Recordings</h1>

            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>IndexedDB Recordings</IonCardTitle>
                </IonCardHeader>

                <IonCardContent>
                    {recordings.map(recording => (
                        <pre key={recording.id}>{JSON.stringify(recording, null, 2)}</pre>
                    ))}
                </IonCardContent>
            </IonCard>
            {recordings.length > 0 && <IonButton onClick={deleteLocalRecordings}>Delete Local Recordings</IonButton>}
        </>
    );
};
